export default __webpack_public_path__ + "static/testimonial2-c787c3878253984a5de37b1cdfffd289.png";